import {useABTest} from "@pg-mono/ab-testing";

import {SEMANTIC_SEARCH_NEW_FLOW_VARIANT, semanticSearchAbTests} from "../semantic_search_ab_tests";

export function useSemanticSearchAbTest() {
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: semanticSearchAbTests.id,
        variants: semanticSearchAbTests.variants,
        withSSR: semanticSearchAbTests.withSSR
    });

    const isSemanticSearchEnabled = canABTestBeRendered && abTestVariant === SEMANTIC_SEARCH_NEW_FLOW_VARIANT;

    return {
        isSemanticSearchEnabled
    };
}
import {useABTest} from "@pg-mono/ab-testing";

import {SEMANTIC_SEARCH_NEW_FLOW_VARIANT, semanticSearchAbTests} from "../semantic_search_ab_tests";

export function useSemanticSearchAbTest() {
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: semanticSearchAbTests.id,
        variants: semanticSearchAbTests.variants,
        withSSR: semanticSearchAbTests.withSSR
    });

    const isSemanticSearchEnabled = canABTestBeRendered && abTestVariant === SEMANTIC_SEARCH_NEW_FLOW_VARIANT;

    return {
        isSemanticSearchEnabled
    };
}
